<template>
    <div v-if="result" class="flex flex-column p-3">

        <div class="grid mb-3">
            <div class="col-6">
                <span class="Paragraph-Medium">Subject - </span>
                <span class="Paragraph-Regular">{{ result.subject }}</span>
            </div>
            <div class="col-6">
                <span class="Paragraph-Medium">Exam Name - </span>
                <span class="Paragraph-Regular">{{ result.examName }}</span>
            </div>
        </div>

        <div class="grid mb-4">
            <div class="col-6">
                <span class="Paragraph-Medium">Date - </span>
                <span class="Paragraph-Regular">{{ formatToDisplayDate(result.date) }}</span>
            </div>
            <div class="col-6 flex align-items-center gap-2">
                <span class="Paragraph-Medium">Marks - </span>
                <span class="Paragraph-Regular" :class="getGradeClass(result.marks)">
                    {{ computedGrade(result.marks) }} ({{ result.marks }})
                </span>
            </div>
        </div>

        <div class="flex flex-column mb-4">
            <span class="Paragraph-Medium mb-2">Feedback</span>
            <div class="feedback-box Paragraph-Regular" v-html="result.feedback || 'No feedback provided.'"></div>
        </div>

        <div class="flex flex-wrap justify-content-start gap-2" v-if="!isInstitute">
            <Button label="Edit Result" class="teal-button-small" @click="$emit('edit-result', result)" />
            <Button label="Delete Result" class="p-button-outlined p-button-danger" @click="removeResult" />
        </div>
    </div>

    <div v-else class="p-4">Loading...</div>
</template>

<script setup>
import { defineProps, defineEmits, computed } from "vue";
import Button from "primevue/button";
import { formatToDisplayDate } from "@/utils/cleanups";
import { useConfirm } from "primevue/useconfirm";
import { deleteResult } from "@/api/tutor";
import { notifySuccess, notifyError } from "@/utils/notification";
import { useAuthStore } from "@/stores/authStore";

const authStore = useAuthStore();
const isInstitute = computed(() => authStore.user?.role === 'institute');

const confirm = useConfirm();
const props = defineProps({
    result: {
        type: Object,
        default: null
    },
    studentId: {
        type: String,
        required: true
    }
});

const emit = defineEmits(['edit-result', 'refresh-results', 'back']);

const computedGrade = (marks) => {
    const m = Number(marks);
    if (isNaN(m)) return "-";
    if (m < 40) return "W";
    if (m <= 54) return "S";
    if (m <= 64) return "C";
    if (m <= 74) return "B";
    return "A";
};

const getGradeClass = (marks) => {
    const m = Number(marks);
    if (m >= 40) return 'status-pass';
    return 'status-fail';
}

const removeResult = () => {
    if (!props.result) return;
    confirm.require({
        message: 'Do you want to delete this result permanently?',
        header: 'Delete Confirmation',
        icon: 'pi pi-info-circle',
        rejectLabel: 'Cancel',
        rejectProps: { label: 'Cancel', severity: 'secondary', outlined: true },
        acceptProps: { label: 'Delete', severity: 'danger' },
        accept: async () => {
            try {
                await deleteResult(props.result._id);
                notifySuccess("Success", "Result deleted successfully");
                emit('refresh-results');
            } catch (error) {
                console.error("Error deleting result:", error);
                notifyError("Error", "Failed to delete result");
            }
        },
    });
}
</script>

<style scoped>
.p-button-danger {
    padding: 8px 16px;
    height: 34px;
    font-size: 0.75rem;
}

.teal-button-small {
    padding: 8px 16px;
    height: 34px;
    font-size: 0.75rem;
}

.feedback-box {
    /* padding: 0.5rem; */
    overflow: hidden;
    word-break: break-word;
}

.status-badge {
    border-radius: 50px;
    padding: 4px 12px;
    font-weight: 600;
    font-size: 0.85rem;
    display: inline-block;
}

/* .Paragraph-Medium {
    font-weight: 600;
    color: #374151;
} */

/* .Paragraph-Regular {
    font-weight: 400;
    color: #4b5563;
} */
</style>